module.exports = __webpack_public_path__ + "static/img/icon_gaosu_current.88cb5d11.png";